<template>
  <div class="h-100 df iframe-page">
    <div class="h-100 df fdc w-full">
        <div class="d-flex relative">
            <vs-tabs :color="colorx" v-model="currentTab">
                <vs-tab @click="changeTab(0)" label="By Keyword">
                    <vx-card>
                        <div class="flex items-center relative custom-search">
                            <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                                      placeholder="Search here"
                                      v-on:keyup="getSearchData"
                                      :value="searchQuery" size="large"/>
                            <div class="absolute top-0 right-0 px-4 d-flex items-center" style="height: 100%">
                                <div slot="reset-icon" class="py-4 cursor-pointer" :class="{'flex': searchQuery}"
                                     v-show="searchQuery" style="padding-right: 0 !important;">
                                    <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer"
                                                  @click="() => {searchQuery = '';$store.commit('setState', {searchQuery: ''}); getSearchData()}"/>
                                </div>
                                <div slot="submit-icon" class="flex cursor-pointer"
                                     @click="() => {getSearchData()}"
                                     style="padding-right: 0 !important; position: relative">
                                    <feather-icon icon="SearchIcon" svgClasses="h-6 w-6"
                                                  :class="{'active-search-btn': isLoading}"/>
                                    <div class="loader-block search-loader" v-if="isLoading">
                                        <div class="loading">
                                            <div class="effect-1 effects"></div>
                                            <div class="effect-2 effects"></div>
                                            <div class="effect-3 effects"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5" v-if="showAssetTypeFilter">
                            <div class="vx-col w-full">
                                <vx-input-group>
                                    <div class="d-flex">
<!--                                                                                <span class="label">Media Type: </span>-->
                                        <div class="vx-input-group-append flex-grow">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    v-for="(v, i) in types"
                                                    :key="i"
                                                    @click="() => {toggleAssetType(v.value); search()}"
                                                    class="radiobtn"
                                                    :class="{selected: filters.asset_types.indexOf(v.value) !== -1}">
                                                    {{v.name}}
                                                </vs-button>
                                            </div>
                                        </div>
                                    </div>
                                </vx-input-group>
                            </div>
                        </div>
                    </vx-card>
                </vs-tab>
                <vs-tab @click="changeTab(1)" label="My Library" v-if="showMylib">
                  <vx-card>
                    <div class="flex items-center relative custom-search">
                      <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                                placeholder="Search here"
                                v-on:keyup="fetchUserItems"
                                v-model="filters._search" size="large"/>
                      <div class="absolute top-0 right-0 px-4 d-flex items-center" style="height: 100%">
                        <div slot="reset-icon" class="py-4 cursor-pointer" :class="{'flex': filters._search}"
                             v-show="filters._search" style="padding-right: 0 !important;">
                          <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer"
                                        @click="() => {filters._search = '';}"/>
                        </div>
                        <div slot="submit-icon" class="flex cursor-pointer"
                             @click="() => {fetchUserItems}"
                             style="padding-right: 0 !important; position: relative">
                          <feather-icon icon="SearchIcon" svgClasses="h-6 w-6"
                                        :class="{'active-search-btn': isLoading}"/>
                          <div class="loader-block search-loader" v-if="isLoading">
                            <div class="loading">
                              <div class="effect-1 effects"></div>
                              <div class="effect-2 effects"></div>
                              <div class="effect-3 effects"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-5" v-if="showAssetTypeFilter">
                      <div class="vx-col w-full">
                        <vx-input-group>
                          <div class="d-flex">
                            <!--                                                                                <span class="label">Media Type: </span>-->
                            <div class="vx-input-group-append flex-grow">
                              <div class="append-text btn-addon">
                                <vs-button
                                  color="primary"
                                  type="border"
                                  v-for="(v, i) in types"
                                  :key="i"
                                  @click="() => {toggleAssetType(v.value)}"
                                  class="radiobtn"
                                  :class="{selected: filters.asset_types.indexOf(v.value) !== -1}">
                                  {{v.name}}
                                </vs-button>
                              </div>
                            </div>
                          </div>
                        </vx-input-group>
                      </div>
                    </div>

                  </vx-card>
                </vs-tab>
                <vs-tab @click="changeTab(2)" v-if="showTabs" label="By Concept">
                    <div class="con-tab-ejemplo advanced-search ">
                        <vx-card>
                            <div class="vx-row gutter-half mb-3 ">
                                <div class="vx-col w-full sm:w-full md:w-1/2">
                                    <vx-input-group class="concepts-search w-100">
                                        <div class="d-flex">
                                            <div class="relative flex-grow">
                                                <vs-input loading v-model="filters._search"
                                                          style="width: 100%"
                                                          placeholder="Type at least 3 characters."
                                                          class="has-icons"
                                                />
                                                <div class="icons">
                                                    <feather-icon v-if="filters._search" icon="XIcon"
                                                                  svgClasses="h-6 w-6 cursor-pointer"
                                                                  @click="clearSearchConcept"
                                                                  style="opacity: 0.7; margin-right: 5px;"/>
                                                    <div v-if="isLoading" class="vs-input__loading"
                                                         style="margin-left: 5px;"/>
                                                    <feather-icon
                                                        v-else
                                                        style="margin-right: 5px;"
                                                        icon="SearchIcon" svgClasses="h-6 w-6"
                                                        :class="{'active-search-btn': isLoading}"/>
                                                </div>
                                            </div>
                                        </div>
                                    </vx-input-group>
                                </div>
                                <div class="vx-col w-full sm:w-full md:w-1/2">
                                    <div class="d-flex align-center">
                                        <!--                                    <span class="label">Grade: </span>-->
                                        <b class="pr-4">K</b>
                                        <vs-slider color="primary" :min="1" :max="12" :step="1" :value="filters.grade"
                                                   @input="gradeOnChangeConcept"/>
                                        <b class="pl-4">12</b>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-row gutter-half mb-3 d-flex align-center">
                                <div class="vx-col w-full sm:w-full md:w-1/4">
                                    <div class="d-flex align-center"
                                         :class="{'filter-disabled': filters._search.length < 3}">
                                        <!--                                    <span class="label">Subject: </span>-->
                                        <v-select name="subject"
                                                  class="flex-grow custom-width left"
                                                  placeholder="Subject"
                                                  :options="subjects"
                                                  :disabled="filters._search.length < 3"
                                                  :searchable="false"
                                                  @input="getUnitsConcept"
                                                  v-model="filters.subject">
                                            <template #list-header>
                                                <li style="text-align: center" v-if="!subjects.length">Loading
                                                    Subjects...
                                                </li>
                                            </template>
                                            <template #no-options="{ search, searching, loading }">
                                                <span></span>
                                            </template>
                                        </v-select>

                                    </div>
                                </div>
                                <div class="vx-col w-full sm:w-full md:w-1/4">
                                    <div class="d-flex align-center" :class="{'filter-disabled': !units.length}">
                                        <!--                                    <span class="label">Unit: </span>-->
                                        <v-select name="subject"
                                                  class="flex-grow custom-width left"
                                                  placeholder="Unit"
                                                  :options="units"
                                                  :disabled="!units.length"
                                                  @input="getChaptersConcept"
                                                  v-model="filters.unit">
                                            <template #list-header>
                                                <li style="text-align: center" v-if="!units.length">Loading Units...
                                                </li>
                                            </template>
                                            <template #no-options="{ search, searching, loading }">
                                                <span></span>
                                            </template>
                                        </v-select>

                                    </div>
                                </div>
                                <div class="vx-col w-full sm:w-full md:w-1/4">
                                    <div class="d-flex align-center" :class="{'filter-disabled': !chapters.length}">
                                        <!--                                    <span class="label">Chapter: </span>-->
                                        <v-select name="subject"
                                                  class="flex-grow custom-width right"
                                                  placeholder="Chapter"
                                                  :options="chapters"
                                                  :disabled="!chapters.length"
                                                  @input="getTopicsConcept"
                                                  v-model="filters.chapter">
                                            <template #list-header>
                                                <li style="text-align: center" v-if="!chapters.length">Loading
                                                    Chapters...
                                                </li>
                                            </template>
                                            <template #no-options="{ search, searching, loading }">
                                                <span></span>
                                            </template>
                                        </v-select>

                                    </div>
                                </div>
                                <div class="vx-col w-full sm:w-full md:w-1/4"
                                     :class="{'filter-disabled': !topics.length}">
                                    <div class="d-flex align-center">
                                        <!--                                    <span class="label">Topic: </span>-->
                                        <v-select name="subject"
                                                  class="flex-grow custom-width right"
                                                  placeholder="Topic"
                                                  :options="topics"
                                                  :disabled="!topics.length"
                                                  v-model="filters.topic">
                                            <template #list-header>
                                                <li style="text-align: center" v-if="!topics.length">Loading Topics...
                                                </li>
                                            </template>
                                            <template #no-options="{ search, searching, loading }">
                                                <span></span>
                                            </template>
                                        </v-select>

                                    </div>
                                </div>
                            </div>
                            <div class="vx-row gutter-half"  v-if="showAssetTypeFilter">
                                <div class="vx-col w-full">
                                    <vx-input-group>
                                        <div class="d-flex">
                                            <!--                                        <span class="label">Media Type: </span>-->
                                            <div class="vx-input-group-append flex-grow">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        color="primary"
                                                        type="border"
                                                        v-for="(v, i) in types"
                                                        :key="i"
                                                        @click="toggleAssetType(v.value)"
                                                        class="radiobtn"
                                                        :class="{selected: filters.asset_types.indexOf(v.value) !== -1}">
                                                        {{v.name}}
                                                    </vs-button>
                                                </div>
                                            </div>
                                        </div>
                                    </vx-input-group>
                                </div>
                            </div>
                        </vx-card>
                    </div>
                </vs-tab>
                <vs-tab @click="changeTab(3)" v-if="showTabs" label="Topic explorer">
                    <div class="con-tab-ejemplo advanced-search">
                        <vx-card>
                            <div class="vx-row gutter-half mb-3">
                                <div class="vx-col w-full">
                                    <vx-input-group class="input-flex">
                                        <div class="text-center mr-3">
                                            <b>Grade: </b>
                                        </div>
                                        <div class="d-flex justify-center w-full">
                                            <div class="vx-input-group-append flex-grow">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        color="primary"
                                                        type="border"
                                                        v-for="(v, i) in 12"
                                                        :key="i"
                                                        @click="toggleYearLevel(v)"
                                                        class="radiobtn"
                                                        :class="{selected: filters.grade_in.indexOf(v) !== -1}">
                                                        {{v}}
                                                    </vs-button>
                                                </div>
                                            </div>
                                        </div>
                                    </vx-input-group>
                                </div>
                            </div>
                            <div class="vx-row gutter-half select-filters">
                                <div class="vx-col w-full sm:w-full md:w-1/5">
                                    <!--                                <div class="text-center pb-2"><b>Subject: </b></div>-->
                                    <div class="d-flex align-center">
                                        <v-select name="subject"
                                                  class="flex-grow custom-width left"
                                                  placeholder="Subject"
                                                  :options="subjects"
                                                  :searchable="false"
                                                  @input="getUnits"
                                                  v-model="filters.subject">
                                            <template #list-header>
                                                <li style="text-align: center" v-if="!subjects.length">Loading
                                                    Subjects...
                                                </li>
                                            </template>
                                            <template #no-options="{ search, searching, loading }">
                                                <span></span>
                                            </template>
                                        </v-select>

                                    </div>
                                </div>
                                <div class="vx-col w-full sm:w-full md:w-1/5"
                                     :class="{'filter-disabled': !units.length}">
                                    <!--                                <div class="text-center pb-2"><b>Unit: </b></div>-->
                                    <div class="d-flex align-center">
                                        <v-select name="subject"
                                                  class="flex-grow custom-width left"
                                                  placeholder="Unit"
                                                  :options="units"
                                                  :disabled="!units.length"
                                                  @input="getChapters"
                                                  v-model="filters.unit">
                                            <template #list-header>
                                                <li style="text-align: center" v-if="!units.length">Loading Units...
                                                </li>
                                            </template>
                                            <template #no-options="{ search, searching, loading }">
                                                <span></span>
                                            </template>
                                        </v-select>

                                    </div>
                                </div>
                                <div class="vx-col w-full sm:w-full md:w-1/5"
                                     :class="{'filter-disabled': !chapters.length}">
                                    <!--                                <div class="text-center pb-2"><b>Chapter: </b></div>-->
                                    <div class="d-flex align-center">
                                        <v-select name="subject"
                                                  class="flex-grow custom-width right"
                                                  placeholder="Chapter "
                                                  :options="chapters"
                                                  :disabled="!chapters.length"
                                                  @input="getTopics"
                                                  v-model="filters.chapter">
                                            <template #list-header>
                                                <li style="text-align: center" v-if="!chapters.length">Loading
                                                    Chapters...
                                                </li>
                                            </template>
                                            <template #no-options="{ search, searching, loading }">
                                                <span></span>
                                            </template>
                                        </v-select>

                                    </div>
                                </div>
                                <div class="vx-col w-full sm:w-full md:w-1/5"
                                     :class="{'filter-disabled': !topics.length}">
                                    <!--                                <div class="text-center pb-2"><b>Topic: </b></div>-->
                                    <div class="d-flex align-center">
                                        <v-select name="subject"
                                                  class="flex-grow custom-width right"
                                                  placeholder="Topic"
                                                  :options="topics"
                                                  :disabled="!topics.length"
                                                  @input="getTitles"
                                                  v-model="filters.topic">
                                            <template #list-header>
                                                <li style="text-align: center" v-if="!topics.length">Loading Topics...
                                                </li>
                                            </template>
                                            <template #no-options="{ search, searching, loading }">
                                                <span></span>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="vx-col w-full sm:w-full md:w-1/5"
                                     :class="{'filter-disabled': !titles.length}">
                                    <!--                                <div class="text-center pb-2"><b>Concept: </b></div>-->
                                    <div class="d-flex align-center">
                                        <v-select name="subject"
                                                  class="flex-grow custom-width right"
                                                  placeholder="Concept"
                                                  :options="titles"
                                                  :disabled="!titles.length"
                                                  v-model="filters.title">
                                            <template #list-header>
                                                <li style="text-align: center" v-if="!titles.length">Loading
                                                    Concepts...
                                                </li>
                                            </template>
                                            <template #no-options="{ search, searching, loading }">
                                                <span></span>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-row gutter-half"  v-if="showAssetTypeFilter">
                                <div class="vx-col w-full">
                                    <vx-input-group>
                                        <div class="d-flex">
                                            <!--                                        <span class="label">Media Type: </span>-->
                                            <div class="vx-input-group-append flex-grow">
                                                <div class="append-text btn-addon">
                                                    <vs-button
                                                        color="primary"
                                                        type="border"
                                                        v-for="(v, i) in types"
                                                        :key="i"
                                                        @click="toggleAssetType(v.value)"
                                                        class="radiobtn"
                                                        :class="{selected: filters.asset_types.indexOf(v.value) !== -1}">
                                                        {{v.name}}
                                                    </vs-button>
                                                </div>
                                            </div>
                                        </div>
                                    </vx-input-group>
                                </div>
                            </div>
                        </vx-card>
                    </div>
                </vs-tab>
            </vs-tabs>
            <vs-button
                v-if="!showAssetTypeFilter && !isResumableUpload"
                class="upload-btn small"
                type="gradient"
                color="#7367F0"
                gradient-color-secondary="#CE9FFC"
                @click="upload">
                <span>UPLOAD</span>
            </vs-button>
            <vs-button
                v-if="!showAssetTypeFilter && isResumableUpload"
                class="upload-btn small"
                type="gradient"
                color="#7367F0"
                gradient-color-secondary="#CE9FFC"
                @click="uploadNew">
                <span>UPLOAD</span>
            </vs-button>
        </div>
        <div class="pr df fdc" style="overflow: hidden; flex-grow: 1">
            <div class="loader-block loader-block2" v-if="isLoading">
                <div class="loading">
                    <div class="effect-1 effects"></div>
                    <div class="effect-2 effects"></div>
                    <div class="effect-3 effects"></div>
                </div>
            </div>
            <div class="vx-row mb-0 pt-4" style="overflow-y: auto; overflow-x: hidden; user-select: none"  >
                <div class="vx-col custom-asset-card" :class ="currentItem ? 'w-full sm:w-1/2 md:w-1/4 lg:w-1/5 xl:w-1/5': 'w-1/3 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6'" v-for="(item, index) in items" :key="index">
                    <vx-card @click="selectItem(item)" :class="{'selected': item._id === currentItem._id}">
                        <slot/>
                        <div slot="no-body" class="card-img-block">
                            <HoverThumb
                                imgClassName="responsive card-img-top"
                                :asset="item"
                                :main="item.thumbnail"
                                :list="item.thumbnails"/>
                        </div>
                        <div class="l-title">{{ item.title || item.name }}</div>
                    </vx-card>
                </div>
            </div>
          <div class="mb-3 mt-5" style="text-align: center" v-if="items.length && items.length % (currentPage * itemsPerPage) === 0">
            <vs-button color="primary" :disable="isLoading" @click="loadMore" style="width: 150px">
              Load more
            </vs-button>
          </div>
<!--            <div class="pagination-block">-->
<!--                <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-4" v-if="totalPages > 1"-->
<!--                               ></vs-pagination>-->
<!--            </div>-->
        </div>
    </div>
    <div v-if="currentItem" class="currentItem h-100 pr">
          <div class="loader-block loader-block2" v-if="isLoading">
              <div class="loading">
                  <div class="effect-1 effects"></div>
                  <div class="effect-2 effects"></div>
                  <div class="effect-3 effects"></div>
              </div>
          </div>
          <div class="df fdc h-100 pr">
              <div v-if="currentTab === 1">
                  <feather-icon class="ml-delete-item" icon="DeleteIcon" @click="deleteVariation" />
              </div>
              <div v-if="currentItem.asset_type === '3D' || currentItem.asset_type === 'vr_image' "
                   class="iframeContainer mb-3">
                  <iframe v-if="currentItem.asset_type === '3D' && asset && asset.variants[currentVariationIndex] && asset.variants[currentVariationIndex].coobo_library_link" :src="getIframeSrc()" allowfullscreen=""
                          frameborder="0" style="width: 100%; height:100%"/>
                  <div class="dfaicjcc absolute100 is-processing" v-else>Asset is processing</div>
                  <iframe v-if="currentItem.asset_type === 'vr_image'" allowfullscreen="" frameborder="0"
                          :src="getIframeSrc()" style="width: 100%; height:100%"/>
              </div>
              <div v-if="asset && currentItem.asset_type === 'image' || currentItem.asset_type === 'illustration'"
                   :class="{'mb-3': asset}"
                   style="padding-top: 70%; position: relative; box-shadow: inset 0 0 0 1px lightgray">
                  <img :src="getIframeSrc()"
                       style="width:100%;height:100%;position:absolute;top:0;left:0;object-fit: contain;"/>
              </div>
              <div v-if="asset && (currentItem.asset_type === 'video' || currentItem.asset_type === 'animation')" :class="{'mb-3': asset}" style="max-height: 250px">
                  <video v-if="currentItem.asset_type === 'video' || currentItem.asset_type === 'animation'" autoplay
                         controls allowfullscreen="" frameborder="0" :src="getIframeSrc()"
                         style="width: 100%; height:100%"/>
              </div>
              <div v-if="asset && currentItem.asset_type === 'audio'" :class="{'mb-3': asset}" style="padding: 50px 5px; box-shadow: inset 0 0 0 1px lightgray">
                <audio controls :src="getIframeSrc()" style="width: 100%"/>
              </div>
              <div class="vx-row mb-3">
                  <div class="vs-col w-2/3" style="word-wrap: break-word;">
                      <h5>{{currentItem.title}}</h5>
                  </div>
                  <div class="vs-col w-1/3">
                      <vs-button class="w-full"
                                 v-if="asset"
                                 :disabled="(currentItem.asset_type === '3D' && (!asset.variants[currentVariationIndex] || !asset.variants[currentVariationIndex].coobo_library_link)) || (currentItem.asset_type !== '3D' && (!asset.variants.length || !asset.variants[currentVariationIndex].ready_links.length))"
                                 :title="currentItem.asset_type === '3D' || (asset.variants.length > 0 && asset.variants[currentVariationIndex].ready_links.length) > 0 ? '' : 'No Coobo ready files available'"
                                 type="gradient"
                                 color="#7367F0"
                                 gradient-color-secondary="#CE9FFC"
                                 @click="insertAssets">
                          <span>Insert</span>
                      </vs-button>
                  </div>
              </div>
            <div class="d-flex align-center mb-5" v-if="asset">
              <div class="mr-3">
                <h5>Variation:</h5>
              </div>
              <div class="w-100" style="height: 38px;">
                <v-select
                  name="variation"
                  class="hide-search break-word thumbs-dropdown"
                  placeholder="Variation"
                  label="name"
                  :options="asset.variants"
                  :disabled="!asset.variants.length"
                  :searchable="false"
                  :clearable="false"
                  @input="changeVariation"
                  v-model="currentVariation">
                </v-select>
              </div>
            </div>

              <vs-collapse class="collapse">
                  <vs-collapse-item>
                      <div slot="header">
                          Details
                      </div>
                      <p>Asset ID: <b>{{currentItem._id}}</b></p>

                      <p v-if="asset && asset.variants.length > 0">
                          Variant ID: <b>{{asset.variants[currentVariationIndex].id}}</b>
                      </p>
                      <p v-if="asset && asset.asset_type === 'image' &&
                            asset.variants.length > 0 &&
                            asset.variants[currentVariationIndex].ready_links.length >0
                            ">
                          Size: <b>{{asset.variants[currentVariationIndex].ready_links[0].size}} kB</b>
                      </p>
                      <p v-if="asset && asset.asset_type === 'image' &&
                            asset.variants.length >0 &&
                            asset.variants[currentVariationIndex].ready_links.length >0
                            ">
                          Width: <b>{{asset.variants[currentVariationIndex].ready_links[0].width}} px</b>
                      </p>
                      <p v-if="asset && asset.asset_type === 'image' &&
                            asset.variants.length >0 &&
                            asset.variants[currentVariationIndex].ready_links.length >0
                            ">
                          Height: <b>{{asset.variants[currentVariationIndex].ready_links[0].height}} px</b>
                      </p>
                  </vs-collapse-item>
              </vs-collapse>

              <h5 class="mt-3">Related content</h5>
              <div class="vx-row mt-3 h-100" style="overflow-y: auto; align-items:flex-start">
                  <div class="vx-col pt-4 custom-asset-card sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2" v-for="(item, index) in related_assets" :key="index">
                      <vx-card @click="selectItem(item)" :class="{'selected': item._id === currentItem._id}" >
                          <slot/>
                          <div slot="no-body" class="card-img-block">
                              <HoverThumb
                                  imgClassName="responsive card-img-top"
                                  :asset="item"
                                  :main="item.thumbnail"
                                  :list="item.thumbnails"/>
                          </div>
                          <div class="r-title">{{ item.title }}</div>
                      </vx-card>
                  </div>
              </div>
          </div>
  </div>
    <processing-asset :variation="currentVariation" :cancel="cancel" :getVariantData="getVariantData" v-if="isVariationOverlay && currentVariation && currentVariation.coobo_library_link_priority_queue && currentVariation.coobo_library_link_priority_queue.status != 'done'"/>
    <template v-if="!showAssetTypeFilter && isResumableUpload">
      <div v-show="false">
        <resumable-upload ref="resumableUpload" :fileType="fileType" v-on:abort="abortResumableUpload" title="Coobo-ready Files" type="ready_links" v-on:addUploadedFile="addUploadedFile" v-if="isResumableUpload"></resumable-upload>
      </div>
    </template>
  </div>
</template>

<script>
    import axios from 'axios'
    import HoverThumb from "../components/HoverThumb";
    import vSelect from 'vue-select';
    import processingAsset from '../components/ProcessingAsset.vue';
    import resumableUpload from '../components/ResumableUpload.vue'

    export default {
        name: 'Iframe',
        components: {HoverThumb,vSelect, processingAsset, resumableUpload},
        head() {
            return {
                title: {
                    inner: 'AMP',
                    separator: ' ',
                    complement: ''
                },
                meta: [
                    {hid: 'description', name: 'description', content: ''}
                ]
            }
        },
        data() {
            return {
              orderBy: {
                  'order': 'desc',
                  'order_by': 'updatedAt'
              },
              colorx:'success',
              searchQuery: '',
              axiosInstance: false,
              debounce: false,
              items: [],
              currentPage: 1,
              totalItems: 0,
              itemsPerPage: 24,
              totalPages: 0,
              showImages: false,
              asset:null,
              related_assets:null,
              currentItem:false,
              currentTab:0,
              types: this.$store.state.types,
              filters: {
                  subject: "",
                  _search: "",
                  unit: "",
                  chapter: "",
                  topic: "",
                  title: "",
                  grade: [1, 12],
                  grade_in: [],
                  asset_types: [],
                  order_by: "updatedAt",
                  order: "desc",
              },
              showMylib: false,
              showAssetTypeFilter: true,
              owner: false,
              subjects: [],
              units: [],
              chapters: [],
              topics: [],
              titles: [],
              isLoading: false,
              isVariationOverlay: false,
              currentVariation: null,
              currentVariationIndex: 0,
              isResumableUpload: true,
              fileTypes: {
                "3D": ['zip', '3ds', 'amf', 'awd', 'babylon', 'babylonmeshdata', 'ctm', 'dae', 'fbx', 'glb', 'gltf', 'js', 'json', '3geo', '3mat', '3obj', '3scn', 'kmz', 'md2', 'obj', 'mtl', 'playcanvas', 'ply', 'stk', 'wrl', 'vtk', 'jpg', 'jpeg', 'png', 'gif', 'stl'],
                "image": ['jpg', 'jpeg', 'png', 'gif'],
                "illustration": ['jpg', 'jpeg', 'png', 'gif'],
                "video": ["webm", "mp4"],
                "animation": ["webm", "mp4"],
                "audio": ["wav", "mp3"]
              },
              fileType: [],
              showTabs: false
            }
        },
        mounted() {
            if (this.$route.query.asset_types) {
                this.filters.asset_types = JSON.parse(this.$route.query.asset_types);
                this.fileType = this.fileTypes[this.filters.asset_types[0]];
                this.showAssetTypeFilter = false;
            }
            if (this.$route.query.owner) {
                this.owner = this.$route.query.owner;
                this.$axios.get(`/variants/count?approved_by=${this.owner}${this.filters.asset_types[0] ? "&asset_type="+this.filters.asset_types[0] : "&asset_type_null=false" }`).then((res) => {
                    if (res.data) {
                        this.showMylib = true;
                    }
                });
            }
            this.search();

            let body = document.body;
            body.classList.add("iframeView");
        },
        destroyed(){
            let body = document.body;
            body.classList.remove("iframeView");
        },
        beforeDestroy(){
            this.$root.$off('update_search');
            this.$root.$off('clearSearch');
        },
        methods: {
          abortResumableUpload() {
            this.isResumableUpload = false;
          },
          addUploadedFile(data) {
            let readyFiles = data.data;
            let type = this.filters.asset_types[0];
            let thumb = type !== "3D" ? readyFiles.url : null;
            this.showMylib = true;
            this.$axios.post("/variants",
              {
                name: readyFiles.name + readyFiles.ext,
                asset_type: this.filters.asset_types[0],
                ready_links: [readyFiles._id],
                approved_by: this.owner ? this.owner : 'auto@embibe.com',
                thumbnail: thumb,
                priority: "1",
              }).then(res => {
              this.changeTab(1, (items) => this.selectItem(items[0]));
            })
          },
          changeVariation() {
            this.currentVariationIndex = this.asset.variants.findIndex(item => item._id === this.currentVariation._id);
          },
          getVariantData() {
            let url = '/variants/' + this.currentVariation._id;

            this.$axios.get(url).then(res => {
              setTimeout(() => {
                if (this.currentVariation && this.currentVariation.coobo_library_link_priority_queue && this.currentVariation.coobo_library_link_priority_queue.status != res.data.coobo_library_link_priority_queue.status && (this.currentVariation.coobo_library_link_priority_queue.status != 'done' && this.currentVariation.coobo_library_link_priority_queue.status != 'error')) {
                  this.$set(this.currentVariation, 'coobo_library_link_priority_queue', res.data.coobo_library_link_priority_queue);
                }
                if (res.data.coobo_library_link) {
                  this.currentVariation.coobo_library_link = res.data.coobo_library_link;
                  clearInterval(this.libraryLinkDebounce);
                }
              }, 500)
            }).catch(err => {

            });
          },
          cancel() {
            this.isVariationOverlay = false;
          },
          deleteVariation() {
            const deleteVariation = () => {
              console.log(1,  this.currentItem)
              this.$axios.delete('/variants/' + this.currentItem.variants[0]._id).then(r => {
                this.currentItem = false;
                this.asset = null;
                this.fetchUserItems();
              })
            };
            this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Are you sure you want to delete this item?`,
              text: 'This is a permanent and irreversible action.',
              accept: deleteVariation
            })
          },
          uploadNew() {
            try {
              if (!this.$refs.resumableUpload.fileData || !this.$refs.resumableUpload.fileData.file) {
                this.$refs.resumableUpload.$refs['upload-dropzone'].click();
              }
            } catch (e) {
              console.log(e)
            }
          },
          upload(click) {
              if (this.isUploading) return;
              let button = click.target;
              let input = document.createElement("input");
              input.type = "file";
              input.multiple = this.filters.asset_types[0] === "3D";
              let accept = {
                  "3D": ".zip, .3ds, .amf, .awd, .babylon, .babylonmeshdata, .ctm, .dae, .fbx, .glb, .gltf, .js, .json, .3geo, .3mat, .3obj, .3scn, .kmz, .md2, .obj, .mtl, .playcanvas, .ply, .stk, .wrl, .vtk, .jpg, .jpeg, .png, .gif, .stl",
                  "image": "image/jpeg, image/png, image/gif",
                  "illustration": "image/jpeg, image/png, image/gif",
                  "video": "video/webm, video/mp4",
                  "animation": "video/webm, video/mp4",
                  "audio": "audio/wav, audio/mp3",
              }
              let modelExtensions = ['fbx', 'glb', 'gltf', 'obj'];
              let type = this.filters.asset_types[0];
              input.accept = accept[type];
              input.click();
              input.addEventListener("change", (e) => {
                  if (e.target.files.length) {
                      this.isUploading = true;
                      this.$vs.loading({
                          background: "primary",
                          color: "#fff",
                          container: button,
                          scale: 0.45
                      })

                      let name = e.target.files[0].name
                      if (type === "3D") {
                          let model = [...e.target.files].find(f => modelExtensions.indexOf(f.name.split(".").pop().toLowerCase()) !== -1);
                          if (!model) {
                              this.$vs.notifyWrapper({color:'danger', fixed: true, title:'Validation error', text:'At least one model file required'});
                              this.isUploading = false;
                              setTimeout(() => {
                                  this.$vs.loading.close(button);
                              }, 100)
                              input.remove();
                              return;
                          } else {
                              name = model.name;
                              this.isVariationOverlay = true;
                          }
                      }
                      Promise.all([...e.target.files].map(file => {
                          return new Promise(resolve => {
                              let formData = new FormData();
                              formData.append("files", file)
                              this.$axios.post('/' + this.$store.state.filesUrl, formData).then((res) => {
                                  resolve(res.data[0]);
                              })
                          })
                      })).then(readyFiles => {
                          let thumb = type !== "3D" && readyFiles && readyFiles[0] && readyFiles[0].formats && readyFiles[0].formats.thumbnail ? readyFiles[0].formats.thumbnail.url : null;
                          this.showMylib = true;
                          this.$axios.post("/variants",
                              {   name: name,
                                  asset_type: this.filters.asset_types[0],
                                  ready_links: readyFiles,
                                  approved_by: this.owner,
                                  thumbnail: thumb,
                                  priority: "1"
                              }).then(res => {
                              this.changeTab(1, (items) => this.selectItem(items[0]));
                              input.remove();
                              this.isUploading = false;
                              setTimeout(() => {
                                  this.$vs.loading.close(button);
                              }, 100)
                          })
                      })
                  } else {
                      input.remove();
                  }

              })
          },
          changeTab(tabInd, cb){
              this.currentTab = tabInd;
              this.resetData()
              switch (tabInd) {
                  case 0: {
                      this.search();
                      break;
                  }
                  case 2: {
                      this.getSubjectsConcept();
                      this.fetchItems(`/assets/adv-search?${this.filtersQueryConcept}`);
                      break;
                  }
                  case 3: {
                      this.getSubjects();
                      break;
                  }
                  case 1: {
                      this.fetchUserItems(cb);
                      break;
                  }
                  default:
                      break;
              }
          },
          getIframeSrc() {
              if (!this.asset || !this.asset.variants[this.currentVariationIndex]) return null;
              let data =  this.asset.variants[this.currentVariationIndex];
              let type  = this.asset.asset_type;
              switch (type) {
                  case "3D": {
                      if (data.coobo_library_link) return `${data.coobo_library_link}?no_ui_controls`;
                      else return ``
                  }
                  case "image":
                  case "illustration": {
                      return data.thumbnail || "/img/zip.png"
                  }
                  case "vr_image": {
                      let images = data.ready_links.filter(l => l.mime && l.mime.indexOf("image") !== -1)
                      if (images[0] && images[0].url) return `/panorama-viewer/viewer.html?panorama=${images[0].url}&autoLoad=true&autoRotate=2`;
                      break;
                  }
                  case "video":
                  case "animation": {
                      let videos = [...data.ready_links, ...data.source_links].filter(l => l.mime && l.mime.indexOf("video") !== -1)
                      if (videos[0] && videos[0].url) return videos[0].url;
                      break;
                  }
                  case "audio": {
                      let audios = [...data.ready_links, ...data.source_links].filter(l => l.mime && l.mime.indexOf("audio") !== -1)
                      if (audios[0] && audios[0].url) return audios[0].url;
                      break;
                  }
                  default: {
                      return null;
                  }
              }
              return false;
          },
          startInterval() {
              clearInterval(this.cooboLibInterval);
              if (this.axiosIntervalInstance) {
                  this.axiosIntervalInstance.cancel()
              }
              this.cooboLibInterval = setInterval(() => {
                  let id = this.asset.variants[this.currentVariationIndex]._id
                  const CancelToken = axios.CancelToken;
                  const source = CancelToken.source();
                  this.axiosIntervalInstance = source;
                  this.$axios.get("/variants/" + id, {cancelToken: source.token}).then(res => {
                    if (this.currentVariation && (!this.currentVariation.coobo_library_link_priority_queue || (this.currentVariation.coobo_library_link_priority_queue.status != res.data.coobo_library_link_priority_queue.status && (this.currentVariation.coobo_library_link_priority_queue.status != 'done' && this.currentVariation.coobo_library_link_priority_queue.status != 'error')))) {
                      this.$set(this.currentVariation, 'coobo_library_link_priority_queue', res.data.coobo_library_link_priority_queue);
                    }
                    if (res.data.coobo_library_link) {
                      let index = this.currentVariation ? this.asset.variants.findIndex(item => item._id === this.currentVariation._id) : 0;
                      this.asset.variants[index] = res.data;
                      clearInterval(this.cooboLibInterval);
                      this.$forceUpdate();
                    }
                  }).catch(e => {
                      console.log('catch_interval', e)
                  })
              }, 5000)
          },
          getAsset(assetId = null) {
              if (assetId) {
                  let url = '/assets/' + assetId;
                  this.$axios.get(url).then(res => {
                      res.data.keywords = res.data.keywords.reduce((acc, k) => {
                          if (acc.indexOf(k) === -1) {
                              acc.push(k);
                          }
                          return acc;
                      }, [])

                      this.asset = res.data;
                      if (res.data.variants && res.data.variants[0]) {
                        this.currentVariation = res.data.variants[0];
                        this.currentVariationIndex = 0;
                      }
                      if (this.asset.asset_type === "3D" && this.asset.variants[this.currentVariationIndex] && !this.asset.variants[this.currentVariationIndex].coobo_library_link ) {
                          this.startInterval();
                      }
                      this.getRelatedAssets(this.asset);
                      if (this.asset.notes && this.asset.notes.length) {
                          this.asset.notes = this.asset.notes.replace(/&amp;#13;&amp;#10;|&#13;&#10;/g, "\n")
                          this.asset.notes = this.asset.notes.replace(/,+/g, ",")
                      }
                  }).catch(e => {
                      this.isError = true;
                      document.querySelector('.content-wrapper').classList.add('custom-content-wrapper')
                      console.log('catch_search', e)
                  })
              } else {
                  let res = {
                      "animated": true,
                      "asset_id": "",
                      "asset_type": "3D",
                      "attribution_text": "",
                      "category": "",
                      "description": "",
                      "keywords": [],
                      "license_partner": "",
                      "license_type": "Embibe Internal",
                      "license_url": "",
                      "price": "",
                      "currency": "USD",
                      "related_assets": [],
                      "meta_deleted": [],
                      "meta_manual": [],
                      "sub-category": "",
                      "thumbnail": "",
                      "title": "",
                      "visual_style": "",
                      "variants": [],
                      "meta_KG": [],
                      "meta_KGC": [],
                      "meta_deleted_KGC": [],
                      "meta_manual_KGC": [],
                      "is_test": false
                  };

                  this.asset = res;
              }
          },
          selectItem(item) {
              clearInterval(this.cooboLibInterval);
              if (this.currentTab === 1) {
                  let tempAsset = {_id: item._id, asset_type: item.asset_type, variants: [item]}
                  this.currentItem = tempAsset;
                  if (tempAsset.variants && tempAsset.variants[0]) {
                    this.currentVariation = tempAsset.variants[0];
                    this.currentVariationIndex = tempAsset.variants.findIndex(item => item._id === this.currentVariation._id);
                  }
                  this.asset = tempAsset;
                  if (item.asset_type === "3D" && !item.coobo_library_link) {
                      this.startInterval();
                  }
              } else {
                this.currentItem = item
                this.getAsset(item.asset_object_id || item._id)
              }
          },
          resetData(){
              if (this.axiosInstance) {
                  this.axiosInstance.cancel();
              }
              if (this.axiosIntervalInstance) {
                  this.axiosIntervalInstance.cancel()
              }
              clearInterval(this.cooboLibInterval)
              this.items = []
              this.currentPage= 1;
              this.totalItems = 0;
              this.itemsPerPage =24;
              this.totalPages= 0;
              this.currentItem = false;
              this.searchQuery = '';

              this.filters = {
                  subject: "",
                  _search: "",
                  unit: "",
                  chapter: "",
                  topic: "",
                  title: "",
                  grade: [1, 12],
                  grade_in: [],
                  asset_types: this.showAssetTypeFilter ? [] : this.filters.asset_types,
                  order_by: "updatedAt",
                  order: "desc",
              };
              this.totalPages = [];
              this.units = [];
              this.chapters = [];
              this.topics = [];
              this.titles = [];
              this.isLoading= false;
          },
          insertAssets(){
              parent.postMessage(JSON.stringify(Object.assign({}, this.asset.variants[this.currentVariationIndex], {asset_type: this.asset.asset_type})),'*');
          },
          handlePaginationChange() {
              this.items = [];
              if(this.currentTab === 0){
                  this.search();
              }
              if(this.currentTab === 2){
                  this.fetchItems(`/assets/adv-search?${this.filtersQueryConcept}`);
              }
              if(this.currentTab === 1){
                  this.fetchUserItems();
              }
          },
          getRelatedAssets(asset) {
              asset = asset || this.asset;
              let relatedAssets = this.asset.related_assets || [];
              let excluded = this.asset.related_assets_excluded || [];
              let title = this.asset.title
              let asset_type = this.asset.asset_type
              let description = this.asset.description
              excluded = excluded.slice();
              excluded.push(this.asset._id);
              let keywords = this.asset.keywords;
              this.$axios.post("/related-assets?forceAssetType", {
                  keywords,
                  relatedAssets,
                  excluded,
                  title,
                  description,
                  asset_type
              }).then(res => {
                  this.related_assets = res.data;
              }).catch(e => {
                  console.error('catch_related', e.message)
              })
          },
          getOrderByName() {
              if (this.orderBy) {
                  if (this.orderBy.order_by == 'updatedAt') {
                      if (this.orderBy.order == 'asc') {
                          return 'Oldest'
                      } else {
                          return 'Newest'
                      }
                  } else {
                      if (this.orderBy.order == 'asc') {
                          return 'A-Z'
                      } else {
                          return 'Z-A'
                      }
                  }
              } else {
                  return 'Relevance';
              }
          },
          getTypeName(item) {
              if (!item.asset_type) return "";
              return this.$store.state.assetTypes[item.asset_type] || "";
          },
          updateUrl() {
              let path = this.$route.path;
              let qObj = {
                  per_page: this.itemsPerPage
              };
              if (this.filters.asset_types.length) {
                  qObj.asset_types = JSON.stringify(this.filters.asset_types);
              }
              if (this.owner) {
                  qObj.owner = this.owner;
              }

              // if (this.orderBy && this.orderBy.order && this.orderBy.order_by) {
              //     qObj.order_by = this.orderBy.order_by;
              //     qObj.order = this.orderBy.order;
              // }
              if (this.currentPage !== 1) {
                  qObj.page = this.currentPage;
              }
              if (this.searchQuery) {
                  qObj.search = this.searchQuery;
              }
              let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
              let q = "?" + new URLSearchParams(qArr).toString()
              history.pushState(
                  {},
                  null,
                  path+q
              )
          },
          getSearchData(e) {
              if (e && e.target) {
                  this.searchQuery = e.target.value;
              }
              this.items = [];
              clearTimeout(this.fetchDebounce);
              this.fetchDebounce = setTimeout(() => {
                  this.currentPage = 1;
                  this.search()
              },500)
          },

          /**By Concept */
          toggleAssetType(type) {
              let ind = this.filters.asset_types.indexOf(type);
              if (ind === -1) {
                  this.filters.asset_types.push(type)
              } else {
                  this.filters.asset_types.splice(ind, 1)
              }
          },
          /**By Concept */
          clearConcept(fieldName) {
              const  map = ['subjects', 'units', 'chapters', 'topics'].reverse();
              const clearMap = {
                  subjects: () => {this.subjects = []; this.filters.subject = ''},
                  units: () => {this.units = []; this.filters.unit = ''},
                  chapters: () => {this.chapters = []; this.filters.chapter = ''},
                  topics: () => {this.topics = []; this.filters.topic = ''},
              }
              let ind = map.indexOf(fieldName);
              if (ind < 0) return;
              for (let i=0; i<=ind; i++) {
                  clearMap[map[i]]();
              }
          },
          gradeOnChangeConcept(newVal) {
              if (newVal[0] !== this.filters.grade[0] || newVal[1] !== this.filters.grade[1]) {
                  this.filters.grade = newVal;
                  clearTimeout(this.gradeTimeout);
                  this.gradeTimeout = setTimeout(()=> {
                      this.getSubjectsConcept();
                  }, 1000)
              }
          },
          getSubjectsConcept() {
              this.clearConcept("subjects");
              let url = `/subject-list?${this.filtersQuery}`;
              this.$axios.get(url).then(res => {
                  this.subjects = res.data;
              }).catch(e => {
                  console.log(url, e.message)
              })
          },
          getUnitsConcept() {
              this.clearConcept("units");
              let url = `/units-list?${this.filtersQuery}`;
              this.$axios.get(url).then(res => {
                  this.units = res.data;
              }).catch(e => {
                  console.log(url, e.message)
              })
          },
          getChaptersConcept() {
              this.clearConcept("chapters");
              let url = `/chapters-list?${this.filtersQuery}`;
              this.$axios.get(url).then(res => {
                  this.chapters = res.data;
              }).catch(e => {
                  console.log(url, e.message)
              })
          },
          getTopicsConcept() {
              this.clearConcept("topics");
              let url = `/topics-list?${this.filtersQuery}`;
              this.$axios.get(url).then(res => {
                  this.topics = res.data;
              }).catch(e => {
                  console.log(url, e.message)
              })
          },
          clearSearchConcept() {
              this.filters._search = "";
              this.isLoading = false;
              if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                  this.cancelSearchToken.cancel({err: "Operation canceled by user action."});
              }
          },
          loadMore() {
            this.currentPage++;
            this.search(true);
          },
          search(loadMore = false) {
            console.log(loadMore)
              if (!loadMore) {
                this.items = [];
                this.currentPage = 1;
              }
              this.updateUrl();
              const CancelToken = axios.CancelToken;
              const source = CancelToken.source();
              this.isLoading = true;
              let isId = this.searchQuery && this.searchQuery.match(/^[0-9a-fA-F]{24}$/);

              let url = `https://preprodms.embibe.com/fs_ms/v2/ampsearch`;
              let qObj = {
                [isId ? '_limit' : 'size']: this.itemsPerPage,
                [isId ? '_start' : 'start']: (this.currentPage - 1) * this.itemsPerPage
              };
              if (isId) {
                url = `/assets/adv-search`;
                qObj._search = this.searchQuery;
              } else {
                if (this.searchQuery) {
                  qObj.query = this.searchQuery;
                }
              }

              let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);

              if (!isId && this.filters.asset_types.length) {
                qArr.push(...this.filters.asset_types.map(el => ['filter', `asset_type:${el}`]));
              }

              let q = "?" + new URLSearchParams(qArr).toString()
              url += q;
              if (this.axiosInstance) {
                  this.axiosInstance.cancel();
              }
              this.showImages = false;
              this.axiosInstance = source;

              console.log(url);

              this.$axios.get(url, {cancelToken: source.token}).then(res => {
                  if (isId) {
                    this.items = res.data.items;
                  } else {
                    if (res.data && res.data.content && res.data.content.length) {
                      this.items.push(...res.data.content);
                    }
                  }

                  this.axiosInstance = false;
                  this.isLoading = false;
                  setTimeout(() => {
                      this.showImages = true;
                  }, 100)
              }).catch(e => {
                  this.axiosInstance = false;
                  setTimeout(() => {
                      this.showImages = true;
                  }, 100)
                  this.axiosInstance = false;
                  this.isLoading = false;
                  console.log('catch_search', e)
              }).finally(() => {
                  // let countUrl = `/assets/search/count`
                  // delete qObj._sort;
                  // delete qObj._limit;
                  // delete qObj._start;
                  // qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                  // q = "?" + new URLSearchParams(qArr).toString()
                  // countUrl += q;
                  // if (this.axiosInstance) {
                  //     this.axiosInstance.cancel();
                  // }
                  // this.axiosInstance = source2;
                  // this.$axios.get(countUrl, {cancelToken: source2.token}).then(res => {
                  //     this.totalItems = res.data;
                  //     this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
                  //     this.axiosInstance = false;
                  //     this.isLoading = false;
                  // }).catch(e => {
                  //     console.log('catch_search', e)
                  // });
              });
          },
          fetchUserItems(cb) {
              this.items = [];
              this.isLoading = true;
              clearTimeout(this.fetchDebounce);
              this.fetchDebounce = setTimeout(() => {
                  if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                      this.cancelSearchToken.cancel({err: "Operation canceled by new search.", newSearch: true});
                  }
                  this.cancelSearchToken = axios.CancelToken.source();
                  this.$axios.get(`/variants?${this.filtersUserObjQuery}`, {cancelToken: this.cancelSearchToken.token}).then(res => {
                      if (res.data && res.data.length) {
                          this.items = res.data;
                          cb && cb(this.items)
                      }
                      this.totalItems = res.data.total;
                      this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)

                      this.isLoading = false;
                      this.cancelSearchToken = null;

                  }).catch(e => {
                      console.log('catch_search', e)
                      this.items = [];
                      this.isLoading = Boolean(e.message.newSearch);
                      this.cancelSearchToken = null;
                  })
              }, 500)
          },
          fetchItems(url) {
              console.log(url)
              this.items = [];
              if (this.currentTab === 2 && this.filters._search.length < 3) return;
              this.isLoading = true;
              clearTimeout(this.fetchDebounce);
              this.fetchDebounce = setTimeout(() => {
                  if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                      this.cancelSearchToken.cancel({err: "Operation canceled by new search.", newSearch: true});
                  }
                  this.cancelSearchToken = axios.CancelToken.source();
                  this.$axios.get(url, {cancelToken: this.cancelSearchToken.token}).then(res => {
                      if (res.data && res.data.items && res.data.items.length) {
                          this.items = res.data.items;
                      }
                      this.totalItems = res.data.total;
                      this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)

                      this.isLoading = false;
                      this.cancelSearchToken = null;
                  }).catch(e => {
                      console.log('catch_search', e)
                      this.items = [];
                      this.isLoading = Boolean(e.message.newSearch);
                      this.cancelSearchToken = null;
                  })
              }, 500)
          },

          /** Topic explorer */
          toggleYearLevel(g) {
              let ind = this.filters.grade_in.indexOf(g);
              if (ind === -1) {
                  this.filters.grade_in.push(g)
              } else {
                  this.filters.grade_in.splice(ind, 1)
              }
              this.gradeOnChange();
          },
          clear(fieldName) {
            const  map = ['subjects', 'units', 'chapters', 'topics', 'titles'].reverse();
            const clearMap = {
                subjects: () => {this.subjects = []; this.filters.subject = ''},
                units: () => {this.units = []; this.filters.unit = ''},
                chapters: () => {this.chapters = []; this.filters.chapter = ''},
                topics: () => {this.topics = []; this.filters.topic = ''},
                titles: () => {this.titles = []; this.filters.title = ''},
            }
            let ind = map.indexOf(fieldName);
            if (ind < 0) return;
            for (let i=0; i<=ind; i++) {
                clearMap[map[i]]();
            }
          },
          gradeOnChange() {
                  clearTimeout(this.gradeTimeout);
                  this.gradeTimeout = setTimeout(()=> {
                      this.filters.subject = ""
                      this.getSubjects();
                  }, 1000)
          },
          getSubjects() {
              this.clear("subjects");
              let url = `/subject-list?${this.filtersQuery}`;
              this.$axios.get(url).then(res => {
                  this.subjects = res.data;
              }).catch(e => {
                  console.log(url, e.message)
              })
          },
          getUnits() {
              this.clear("units")
              let url = `/units-list?${this.filtersQuery}`;
              this.$axios.get(url).then(res => {
                  this.units = res.data;
              }).catch(e => {
                  console.log(url, e.message)
              })
          },
          getChapters() {
              this.clear("chapters")
              let url = `/chapters-list?${this.filtersQuery}`;
              this.$axios.get(url).then(res => {
                  this.chapters = res.data;
              }).catch(e => {
                  console.log(url, e.message)
              })
          },
          getTopics() {
              this.clear("topics")
              let url = `/topics-list?${this.filtersQuery}`;
              this.$axios.get(url).then(res => {
                  this.topics = res.data;
              }).catch(e => {
                  console.log(url, e.message)
              })
          },
          getTitles() {
              this.clear('titles')
              let url = `/titles-list?${this.filtersQuery}`;
              this.$axios.get(url).then(res => {
                  this.titles = res.data;
              }).catch(e => {
                  console.log(url, e.message)
              })
          },
          clearSearch() {
              this.isLoading = false;
              if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                  this.cancelSearchToken.cancel({err: "Operation canceled by user action."});
              }
          },
        },
        watch: {
            // currentPage: function() {
            //   this.handlePaginationChange()
            // },
            axiosInstance: function() {
                if (this.axiosInstance === false && this.axiosInstance === false) {
                    this.$root.$emit('search_loading', false);
                }
            },

            /**By Concept */
            filtersQueryConcept(next, prev) {
                if (this.currentTab === 2 && !compareObjects(next, prev)) {
                    this.fetchItems(`/assets/adv-search?${this.filtersQueryConcept}`);
                }
            },

            /** Topic explorer */
            filtersObj(next, prev) {
                if (this.currentTab === 3 && !compareObjects(next, prev)) {
                    this.fetchItems(`/assets/adv-search?${this.filtersQuery}`);
                }
            },

            filtersUserObj(next, prev) {
                if (this.currentTab === 1 && !compareObjects(next, prev)){
                    this.fetchUserItems();
                }
            }
        },
        computed: {
            assetClassName(item) {
                let classNames = [];
                classNames.push('type-' + (item.asset_type || "").replace(' ', ''))
                if (!item.variants || !item.variants.length) {
                    classNames.push("is-empty");
                }
                return classNames.join(" ")
            },

            /**By Concept */
            filtersObjConcept() {
                let min = this.filters.grade[0];
                let max = this.filters.grade[1];
                return {
                    _search: this.filters._search,
                    grade_in: JSON.stringify([...Array(max-min+1).keys()].map(k => (k+min).toString())),
                    subject: this.filters.subject,
                    unit: this.filters.unit,
                    chapter: this.filters.chapter,
                    topic: this.filters.topic,
                    _start: (this.currentPage - 1) * this.itemsPerPage,
                    _limit: this.itemsPerPage,
                    asset_types: this.filters.asset_types.length ? JSON.stringify(this.filters.asset_types) : null,
                    order_by: this.filters.order_by,
                    order: this.filters.order,
                }
            },
            filtersQueryConcept() {
                return Object.keys(this.filtersObjConcept).filter(k => Boolean(this.filtersObjConcept[k]) || this.filtersObjConcept[k] === 0).map(k => `${k}=${this.filtersObjConcept[k]}`).join("&")
            },
            /** Topic explorer */
            filtersObj() {
                return {
                    grade_in: JSON.stringify(this.filters.grade_in.map(g => g.toString())),
                    asset_types: this.filters.asset_types.length ? JSON.stringify(this.filters.asset_types) : null,
                    subject: this.filters.subject,
                    unit: this.filters.unit,
                    chapter: this.filters.chapter,
                    topic: this.filters.topic,
                    title: this.filters.title,
                    _start: (this.currentPage - 1) * this.itemsPerPage,
                    _limit: this.itemsPerPage,
                    order_by: this.filters.order_by,
                    order: this.filters.order,
                }
            },
            filtersQuery() {
                return Object.keys(this.filtersObj).filter(k => Boolean(this.filtersObj[k]) || this.filtersObj[k] === 0).map(k => `${k}=${this.filtersObj[k]}`).join("&")
            },
            filtersUserObj() {
                return {
                    name_contains: this.filters._search ? this.filters._search : null,
                    _start: (this.currentPage - 1) * this.itemsPerPage,
                    _limit: this.itemsPerPage,
                    asset_type_null: false,
                    asset_type_in: this.filters.asset_types.length ? (this.showAssetTypeFilter ? this.filters.asset_types : [this.filters.asset_types[0]]) : null,
                    _sort: `updatedAt:desc`,
                    approved_by: this.owner,
                }
            },
            filtersUserObjQuery() {
                return objToQueryString(this.filtersUserObj)
            },
        },

    }
    function objToQueryString(qObj) {
        let qArr = Object.keys(qObj).filter(k => qObj[k] !== null).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), [])
        return new URLSearchParams(qArr).toString()
    }
    /** Topic explorer */
    function compareObjects(object1, object2) {
        return (JSON.stringify(object1) === JSON.stringify(object2))
        // const keys1 = Object.keys(object1);
        // const keys2 = Object.keys(object2);
        //
        // if (keys1.length !== keys2.length) {
        //     return false;
        // }
        //
        // for (let key of keys1) {
        //     if (object1[key] !== object2[key]) {
        //         return false;
        //     }
        // }
        //
        // return true;
    }
</script>

<style lang="scss">
    .custom-asset-card{
        cursor:pointer;
    }
    .custom-asset-card {
        padding: 0 1rem;
    }
    .con-vs-tabs, .con-slot-tabs{
        overflow: unset !important;
    }
    button.isActive{
        border: 1px solid rgba(var(--vs-primary),1);
        background: transparent!important;
        color: rgb(115, 103, 240)
    }
    .collapse{
        padding: 0px;
        background: #fff;
    }
    .iframeContainer{
        position: relative;
        padding-top: 215px;
    }
    .iframeContainer iframe{
        position: absolute;
        top:0px;
        left: 0px;
    }
    .vx-row{
        margin: 0px;
    }
    .loader-block .loading{
        top:10%;
    }
    .currentItem {
        min-width: 350px;
        width: 335px;
        margin-left: 10px;
    }
    .iframe-page .vx-row > .vx-col {
        padding: 0 10px;
    }
    .iframe-page .vx-card {
        margin-bottom: 0;
    }
    .iframe-page .vs-collapse-item--header {
        padding: 10px;
    }
    .iframe-page .vx-card .vx-card__collapsible-content .vx-card__body {
        padding: 10px;
    }
    .iframe-page .vs-input--input.large, .iframe-page .vs-input--placeholder.large {
        padding: 10px !important;
    }
    .l-title {
        font-size: 14px;
        font-weight: 400;
    }
    .r-title {
        font-size: 10px;
        font-weight: 400;
    }

    .iframe-page .loader-block .loading{
        top: 50% !important;
    }
    .iframe-page img {
        pointer-events: none;
    }
    .iframe-page .vs-tabs--content{
        padding: 5px 0 15px;
    }
    .iframe-page .upload-btn {
        position: absolute;
        right: 0;
        width: 150px;
        top: 0;
        font-size: 1rem;
        margin: 3px;
    }
    .iframe-page .upload-btn.isActive {
        background: linear-gradient(30deg, rgb(115, 103, 240) 0%, rgb(206, 159, 252) 100%) !important;
        color: white !important;
        border: none !important;
    }
    .iframe-page .upload-btn * {
        pointer-events: none;
    }
    .iframe-page .is-processing {
        font-size: 28px;
        font-weight: bold;
        box-shadow: inset 0 0 0 1px lightgrey;
    }
    .iframe-page .vx-card.selected {
        box-shadow: 0 0 15px 4px rgb(115,103,240);
    }

    .iframe-page .vs-button:disabled{
        pointer-events: auto;
    }
</style>
